import { SelectOption } from '@common/types/common';
import { InputField } from '@components/utility/inputs';
import { Select } from '@components/utility/selects';
import { IEventCreation } from '@event/types';
import { useFormikContext } from 'formik';

const PRIVACY_OPTIONS: SelectOption[] = [
    {
        label: 'Public',
        value: 'public',
    },
    {
        label: 'Private',
        value: 'private',
    },
];

const SecondStep = () => {
    const { values, handleChange, handleBlur, touched, errors } = useFormikContext<IEventCreation>();

    return (
        <>
            <div className="flex flex-col gap-5">
                <InputField
                    label="Event Title"
                    name="name"
                    fullWidth
                    placeholder="Name your event"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                />
                <Select
                    fullWidth
                    name="privacy"
                    items={PRIVACY_OPTIONS}
                    type="default"
                    label="Select Event Privacy"
                    value={values.privacy ?? ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.privacy && Boolean(errors.privacy)}
                    helperText={touched.privacy && errors.privacy}
                    size="smallest"
                />
            </div>
        </>
    );
};

export { SecondStep };
